// Train page container — "Manuale" (wizard) + "Live" tabs. Mounts the Preact
// Train UI into a single host element inside #page-train, which is otherwise
// empty: the legacy wizard/live markup and its vanilla implementation were
// removed, so this is the only thing that renders the page.

import { render } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { currentUser } from '@/store/user.js';
import { setTrainData, setTrainBridge, requestedTab, consumeRequestedTab } from '@/store/train.js';
import { LogWizard } from './LogWizard.jsx';
import { LiveSession } from './LiveSession.jsx';

function TrainApp() {
  const [tab, setTab] = useState('manual');
  const rt = requestedTab.value;
  useEffect(() => { if (rt) { setTab(rt); consumeRequestedTab(); } }, [rt]);
  const userId = currentUser.value?.uid || 'anon';
  return (
    <div>
      <div style="display:flex;gap:6px;margin-bottom:12px;flex-wrap:wrap">
        <button class={`bm-tab${tab === 'manual' ? ' active' : ''}`} onClick={() => setTab('manual')}>Manuale</button>
        <button class={`bm-tab${tab === 'live' ? ' active' : ''}`} onClick={() => setTab('live')}>Live</button>
      </div>
      {tab === 'manual'
        ? <LogWizard key={`wiz-${userId}`} userId={userId} />
        : <LiveSession key={`live-${userId}`} userId={userId} />}
    </div>
  );
}

// Bridge-facing mount. `host` is the element to render into; `data` is the
// {workouts, settings, exercises} snapshot; `bridge` supplies saveWorkout/onSaved.
export function mountTrain({ host, data, bridge }) {
  if (!host) return;
  if (data) setTrainData(data);
  if (bridge) setTrainBridge(bridge);
  render(<TrainApp />, host);
}

export function unmountTrain(host) {
  if (host) render(null, host);
}
